export const PRIVILEGE_ROUTE = 'privilege';
export const SYSTEM_CORE_ROUTE = 'system-core';
export const APPLICATION_ROUTE = 'application';
export const AUTHENTICATION_ROUTE = 'authentication';
export const SECURE_AUTHENTICATION_ROUTE = 'secure-authentication';

export const getPrivilegeRoute = (route: string, fullURL: boolean = false) => {
    if (fullURL) {
        return `${process.env.PUBLIC_URL}/${PRIVILEGE_ROUTE}/${route}`;
    } else {
        return `/${PRIVILEGE_ROUTE}/${route}`;
    }
}

export const getSystemCoreRoute = (route: string, fullURL: boolean = false) => {
    if (fullURL) {
        return `${process.env.PUBLIC_URL}/${SYSTEM_CORE_ROUTE}/${route}`;
    } else {
        return `/${SYSTEM_CORE_ROUTE}/${route}`;
    }
}

export const getApplicationRoute = (route: string, fullURL: boolean = false) => {
    if (fullURL) {
        return `${process.env.PUBLIC_URL}/${APPLICATION_ROUTE}/${route}`;
    } else {
        return `/${APPLICATION_ROUTE}/${route}`;
    }
}

export const getSecureAuthenticationRoute = (route: string, fullURL: boolean = false) => {
    if (fullURL) {
        return `${process.env.PUBLIC_URL}/${SECURE_AUTHENTICATION_ROUTE}/${route}`;
    } else {
        return `/${SECURE_AUTHENTICATION_ROUTE}/${route}`;
    }
}

export const getAuthenticationRoute = (route: string, fullURL: boolean = false) => {
    if (fullURL) {
        return `${process.env.PUBLIC_URL}/${AUTHENTICATION_ROUTE}/${route}`;
    } else {
        return `/${AUTHENTICATION_ROUTE}/${route}`;
    }
}